import { render } from "./download-config.vue?vue&type=template&id=90962efc"
import script from "./download-config.vue?vue&type=script&lang=ts"
export * from "./download-config.vue?vue&type=script&lang=ts"
script.render = render

export default script